import { createFileRoute } from '@tanstack/react-router'
import { eduInternDetailsSearchSchema } from '@/features/my-edu-interns/intern-details/model/eduInternDetailsSearch'
import { EduInternsInternPage } from '@/pages/internships/ui/EduInternDetailsPage'
export const Route = createFileRoute('/edu-interns_/$internId')({
  validateSearch: eduInternDetailsSearchSchema,
  component: Page,
})
function Page() {
  const { internId } = Route.useParams()
  return <EduInternsInternPage internId={internId} />
}
